import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal }           from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }         from '@ngx-translate/core';

import { CompanyService }   from '../../companies/company.service';
import { InvoiceItemModel } from '../models/invoice.item';
import { InvoiceModel }     from '../models/invoice';
import { MessagesService }  from '../../messages/messages.service';

@Component({
  template: require('./invoice.custom-markup.component.html')
})
export class InvoiceCustomMarkupComponent implements OnInit {
  @Input() invoice : InvoiceModel;
  @Input() item    : InvoiceItemModel;
  @Input() product : any;

  // Company setting: a new invoice has no recorded basis until saved, and markup is only offered while open.
  isTaxInclusive : boolean;

  confirming   = false;
  cost         : number;
  markup       : number = null;
  markupAmount : number = null;
  newRetail    : number = null;

  private readonly maxUnitPrice = 99999999.99;

  constructor (
    public  activeModal      : NgbActiveModal,
    private companyService   : CompanyService,
    private messagesService  : MessagesService,
    private translateService : TranslateService
  ) {}

  ngOnInit () : void {
    this.isTaxInclusive = this.companyService.priceIncludesTax();
    this.cost           = this.isTaxInclusive ? Number(this.product.cost_including_tax) : Number(this.product.cost);
  }

  calculateAmount () : void {
    if (this.markup == null || !(this.cost > 0)) {
      this.markupAmount = null;
      this.newRetail    = null;
      return;
    }
    this.markupAmount = parseFloat((this.cost * this.markup / 100).toFixed(2));
    this.newRetail    = parseFloat((this.cost + this.markupAmount).toFixed(2));
  }

  calculateMarkup () : void {
    if (this.markupAmount == null || !(this.cost > 0)) {
      this.markup    = null;
      this.newRetail = null;
      return;
    }
    this.markup    = parseFloat((this.markupAmount / this.cost * 100).toFixed(2));
    this.newRetail = parseFloat((this.cost + this.markupAmount).toFixed(2));
  }

  cancelConfirm () : void {
    this.confirming = false;
  }

  confirm () : void {
    this.activeModal.close(this.newRetail);
  }

  save () : void {
    if (this.newRetail == null) {
      return;
    }

    if (this.newRetail > this.maxUnitPrice) {
      this.messagesService.error(this.translateService.instant('JS_SPACE.MESSAGES.MARKUP_PRICE_EXCEEDS_MAXIMUM'));
      return;
    }

    this.confirming = true;
  }
}
